module.exports = __webpack_public_path__ + "static/media/magento_development.2d14ffd3.svg";